import { getNextRoute } from '@shared/helpers/Route'

import basketStore from '@shared/store/basket'
import productStructureStore from '@shared/store/productStructure'
import useStatus from '@shared/hooks/useStatus'

import { ROUTE_INDEX, ROUTE_NAME } from '@shared/config/constants'

// HOOKS
const { isPersonalDataValid } = useStatus()

export default [
  {
    beforeEnter: function (to, _from, next) {
      const personsValid = isPersonalDataValid(basketStore.basket.persons)

      if (basketStore.basket.persons.length === 0) {
        return next({
          name: getNextRoute(basketStore.basket),
          replace: true,
          params: {
            lang: to.params.lang
          }
        })
      }

      productStructureStore.ready().then(() => {
        if (!personsValid) {
          next({
            name: getNextRoute(basketStore.basket),
            params: {
              lang: to.params.lang
            }
          })
        } else {
          next()
        }
      })
    },
    component: () => import('@shared/modules/Dvp/screens/ScreenBasket'),
    meta: {
      index: ROUTE_INDEX.BASKET,
      secured: true,
    },
    name: ROUTE_NAME.BASKET,
    path: 'basket/:personId?/:prop?/:productId?/',
    props: route => ({
      personId: route.params.personId,
      prop: route.params.prop,
      productId: route.params.productId,
    }),
  },
]
